export default {
    dashboard: {
        navigation: [
            {
                title: 'Markets',
                to: '/dashboard/markets',
            },
            {
                title: 'Portfolio',
                to: '/dashboard/portfolio',
            },
            {
                title: 'Config',
                to: '/dashboard/configuration',
            },
            {
                title: 'Data',
                to: '/dashboard/data',
            },
            {
                title: 'Documentation',
                to: 'https://documenter.getpostman.com/view/11872913/T17Kd6mE',
                isLink: true,
            },
        ],
    },
};
